import {iCollectionElement} from "./user.apis";
import BaseAPIs, {iApiBasicResponse, iBasicListingResponse} from "./base.apis";
import axios from "axios";
import {iMaster} from "../reducer";
import {Dimension, PricingRegion} from "./price.management.apis";

export interface iCountry extends iCollectionElement {
    name: string,
    alpha_2: string
    alpha_3: string
    isd_code: string
    numeric: string
    pricing_region_id: number
    pricing_region?: PricingRegion
}

export interface iAddressType extends iCollectionElement {
    name: string

}

export interface iAreaOfExpertise extends iCollectionElement {
    name: string

    code: string
}

export interface iDiscipline extends iCollectionElement {
    name: string,
    available: boolean
    code: string
}
export interface iEntityTypes extends iCollectionElement {
    name: string,
    code: string
}
export interface iBookCoverSize extends iCollectionElement {
    name: string,
    code: string,
    dimensions: Dimension,
    threshold: number
}

export interface iGenre extends iCollectionElement {
    name: string,
    available: boolean
    code: string
}

export interface iManuscriptOrigins extends iCollectionElement {
    name: string
    code:string
}

export interface iManuscriptStatuses extends iCollectionElement {
    name: string,
    code:string
}

export interface iAuthorship extends iCollectionElement {
    name: string,
    code: string
}

export interface iDepartment extends iCollectionElement {
    name: string
}

export interface iAccessRight extends iCollectionElement {
    name: string,
    code: string
}

export interface iCountryState extends iCollectionElement {
    country_id: number
    alpha_2: string
    alpha_3: string
    created_at: string
    name: string
}

export interface DraftManuScriptType {
    id: number,
    name: string
}
export interface FinalManuScriptType {
    id: number,
    name: string
}


export interface AccessType {
    id: number,
    name: string,
    code: string
}

export interface BookFeel {
    id: number,
    name: string,
    code: string
}
export interface CoverLook {
    id: number,
    name: string,
    code: string
}


export interface PublicationStatuses {
    available: boolean
    code: string
    id: number
    name: string
}


export interface iRole extends iCollectionElement {
    name: string
}

export interface iCaptcha extends iApiBasicResponse {
    token: string,
    url: string
}

export interface iMultilevelStringOrNumber {
    [key: string]: undefined | string | string[] | number | number[] | boolean | boolean[] | iMultilevelStringOrNumber | iMultilevelStringOrNumber[]
}

export interface iApiListingQuery extends iMultilevelStringOrNumber {
    page: number
    per_page: number
    sort_order: string
    sort_direction: "desc" | "asc"
    keyword: string
    columns: any
    filters: {
        'sort-order'?: string
        type?: string
        search_keyword?: string
        total_items_count?: number
        from?: string
    }
}

export const getEmptyApiListingQuery = (): iApiListingQuery => {
    return {
        filters: {},
        columns: undefined,
        sort_direction: "desc",
        sort_order: "id",
        keyword: "",
        per_page: 10,
        page: 1
    }
};
export default class CommonApis extends BaseAPIs {

    getAllMasters = async (): Promise<iMaster> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/all", {
                headers: {"Content-Type": "application/x-www-form-urlencoded"},
                withCredentials: true,
            })
            .then((res): iMaster => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getCountries = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/countries", {
                headers: {"Content-Type": "application/x-www-form-urlencoded"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iCountry> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getAddressTypes = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/address_types", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iAddressType> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getAreaOfExpertise = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/areas_of_expertise", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iAreaOfExpertise> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getDiscipline = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/disciplines", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iDiscipline> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getManuscriptOrigins = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/manuscript_origins", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iManuscriptOrigins> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getManuscriptStatuses = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/manuscript_statuses", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iManuscriptStatuses> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getGenres = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/genres", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iGenre> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getAuthorships = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/authorships", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iAuthorship> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getAdminRoles = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/admin_roles", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iRole> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getAdminDepartment = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/admin_departments", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iDepartment> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };
    getAdminAccessRight = async (): Promise<any> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/masters/admin_access_rights", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iBasicListingResponse<iAccessRight> => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };

    getCaptchaImage = async (): Promise<iCaptcha> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/captcha/new", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
            })
            .then((res): iCaptcha => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                 return this.handleCatch(error);
            })
    };

    getCaptchaImageLink = (token: string): string => {
        return this.getApiBaseURL() + "/_api/v1/captcha/show/" + token;
    };
}
